/**
 * All valid group-play slot labels for competitor assignments.
 */
export const GROUP_PLAY_SLOTS = Array.from({ length: 6 }, (_, groupIndex) =>
  Array.from({ length: 11 }, (_, playerIndex) => `${groupIndex + 1}.${playerIndex + 1}`)
).flat()

/**
 * Allowed group-play slot values used across public and admin views.
 */
export type GroupPlaySlot = string

/**
 * Repeated matchup pattern that applies to each group.
 */
const GROUP_PLAY_PAIRINGS = [
  [1, 2],
  [1, 3],
  [10, 1],
  [11, 1],
  [2, 3],
  [2, 4],
  [11, 2],
  [3, 4],
  [3, 5],
  [4, 5],
  [4, 6],
  [5, 6],
  [5, 7],
  [6, 7],
  [6, 8],
  [7, 8],
  [7, 9],
  [8, 9],
  [8, 10],
  [9, 10],
  [9, 11],
  [10, 11],
] as const

/**
 * Single public group-play schedule row.
 */
export interface GroupPlayMatchup {
  group: number
  home: string
  away: string
}

/**
 * Full group-play schedule shown on the public Group Play page.
 */
export const GROUP_PLAY_SCHEDULE: GroupPlayMatchup[] = Array.from({ length: 6 }, (_, groupIndex) =>
  GROUP_PLAY_PAIRINGS.map(([home, away]) => ({
    group: groupIndex + 1,
    home: `${groupIndex + 1}.${home}`,
    away: `${groupIndex + 1}.${away}`,
  }))
).flat()
